import {observable, action, runInAction, computed} from 'mobx';
import Api from '../../services/api';
import {ILanguage} from "../../types/ILanguage";
import _ from 'lodash';

class LanguagesStore {
    constructor() {
        this.getAllLanguages();
    }

    @observable public languages:ILanguage[] = [];

    @observable private availableIETFs:string[] = [];
    @observable private selectedIETF:string = '';
    @observable private defaultIETF:string = '';

    @action
    public getAllLanguages = async () => {
        try {
            const languages = await Api.getAllLanguages();
            runInAction(() => {
                this.languages = languages;
            });
        } catch(e) {
            console.log(e);
        }
    };

    @action
    public setAvailableIETFs = (langs:string[]) => {
        this.availableIETFs = langs;
    }

    @action
    public setSelectedIETF = (lang:string|undefined) => {
        this.selectedIETF = lang || '';
    }

    @action
    public setDefaultIETF = (lang:string|undefined) => {
        this.defaultIETF = lang || '';
    }

    @computed
    public get currentIETF() {
        const selectedLanguageIndex = _.chain(this.languages)
                                            .map(l => l.ietf)
                                            .intersection(this.availableIETFs)
                                            .indexOf(this.selectedIETF)
                                            .value();

        return selectedLanguageIndex >= 0 ? this.selectedIETF : this.defaultIETF;
    }

    @computed
    public get currentLanguage(){
        return this.languages.find(l => l.ietf === this.currentIETF);
    }

    @computed
    public get availableLanguages(){
        return this.languages.filter(l => this.availableIETFs.includes(l.ietf));
    }
}

const languagesStore = new LanguagesStore();

export default languagesStore;
